import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function Account() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    dispatch({
      type: "accountData/logOut",
      payload: {},
    });
    /*  window.location.reload(); */
    navigate("/");

    setTimeout(() => {
      localStorage.clear();
      localStorage.removeItem("user");
      localStorage.removeItem("state");
       /*  window.location.reload(); */
      navigate("/");
    }, 200);
  };
  return (
    <app-account _nghost-ng-c1136689866="" className="ng-star-inserted">
      <div _ngcontent-ng-c1136689866="" className="col-md-12">
        <h3
          _ngcontent-ng-c1136689866=""
          className="ps-2 exchange-heading exchange"
        >
          <i _ngcontent-ng-c1136689866="" className="fa fa-user-circle-o" />
          <span _ngcontent-ng-c1136689866="">&nbsp;&nbsp;exchange</span>
        </h3>
      </div>
      <div _ngcontent-ng-c1136689866="" className="containerr">
        <ul _ngcontent-ng-c1136689866="" className="account-nav">
          <li
            _ngcontent-ng-c1136689866=""
            onClick={() => navigate("/myprofile")}
            className="account-tabs"
            tabIndex={0}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              My Profile{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                />
              </span>
            </div>
          </li>
          <li
            _ngcontent-ng-c1136689866=""
            routerlink="/rolling-commission"
            className="account-tabs"
            tabIndex={0}
            onClick={() => navigate("/rolling-commission")}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              Rolling Commission{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                  style={{ color: "#1e1e1e" }}
                />
              </span>
            </div>
          </li>
          <li
            _ngcontent-ng-c1136689866=""
            routerlink="/account-statement"
            className="account-tabs"
            onClick={() => navigate("/account-statement")}
            tabIndex={0}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              Account Statement{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                  style={{ color: "#1e1e1e" }}
                />
              </span>
            </div>
          </li>
          <li
            _ngcontent-ng-c1136689866=""
            routerlink="/bet-history"
            className="account-tabs"
            onClick={() => navigate("/bet-history")}
            tabIndex={0}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              Bets History{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                  style={{ color: "#1e1e1e" }}
                />
              </span>
            </div>
          </li>
          <li
            _ngcontent-ng-c1136689866=""
            routerlink="/profit-loss"
            className="account-tabs"
            tabIndex={0}
            onClick={() => navigate("/profit-loss")}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              Profit &amp; Loss{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                  style={{ color: "#1e1e1e" }}
                />
              </span>
            </div>
          </li>
          <li
            _ngcontent-ng-c1136689866=""
            routerlink="/password-history"
            className="account-tabs"
            tabIndex={0}
            onClick={() => navigate("/password-history")}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              Password History{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                  style={{ color: "#1e1e1e" }}
                />
              </span>
            </div>
          </li>
          <li
            _ngcontent-ng-c1136689866=""
            routerlink="/activity-log"
            className="account-tabs"
            tabIndex={0}
            onClick={() => {
              navigate("/activity-log");
            }}
          >
            <div _ngcontent-ng-c1136689866="" className="tab-name">
              {" "}
              Activity Log{" "}
            </div>
            <div _ngcontent-ng-c1136689866="" className="right-arroww">
              <span _ngcontent-ng-c1136689866="">
                <i
                  _ngcontent-ng-c1136689866=""
                  className="fa fa-angle-right fa-lg"
                  style={{ color: "#1e1e1e" }}
                />
              </span>
            </div>
          </li>
        </ul>
        <div
          onClick={logout}
          _ngcontent-ng-c1136689866=""
          className="logout-btn"
        >
          <a _ngcontent-ng-c1136689866="" className="logout">
            <span _ngcontent-ng-c1136689866="" className="logout-spn">
              LOGOUT{" "}
            </span>
            <i
              _ngcontent-ng-c1136689866=""
              className="fa fa-sign-out ms-2 fa-sm"
              style={{ color: "#fafafa" }}
            />
          </a>
        </div>
      </div>
      <div
        _ngcontent-ng-c1136689866=""
        id="betStack"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        className="modal fade"
      >
        <div
          _ngcontent-ng-c1136689866=""
          role="document"
          className="modal-dialog"
        >
          <div _ngcontent-ng-c1136689866="" className="modal-content">
            <div _ngcontent-ng-c1136689866="" className="modal-body p-0">
              <div _ngcontent-ng-c1136689866="" className="overlay right-side">
                <div
                  _ngcontent-ng-c1136689866=""
                  id="settingSlide"
                  className="side-wrap setting-wrap"
                >
                  <div _ngcontent-ng-c1136689866="" className="side-head">
                    <h3 _ngcontent-ng-c1136689866="" className="a-setting mb-0">
                      <i
                        _ngcontent-ng-c1136689866=""
                        className="fa fa-cog fa-lg mr-2"
                        style={{ marginRight: 5 }}
                      />{" "}
                      Setting
                    </h3>
                    <a
                      _ngcontent-ng-c1136689866=""
                      href="javascript:;"
                      id="settingClose"
                      className="close ui-link"
                    >
                      <i
                        _ngcontent-ng-c1136689866=""
                        aria-hidden="true"
                        data-bs-dismiss="modal"
                        className="fa fa-times"
                      />
                    </a>
                  </div>
                  <div
                    _ngcontent-ng-c1136689866=""
                    id="coinList"
                    className="side-content"
                  >
                    <h3 _ngcontent-ng-c1136689866="">Stake</h3>
                    <div
                      _ngcontent-ng-c1136689866=""
                      style={{ paddingLeft: 8, paddingRight: 19 }}
                    >
                      <div
                        _ngcontent-ng-c1136689866=""
                        className="row row5 mb-1 desktop-pl"
                      >
                        <div _ngcontent-ng-c1136689866="" className="col-4">
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="button-title"
                            style={{ fontSize: 14, marginLeft: "-2px" }}
                          >
                            <span _ngcontent-ng-c1136689866="">
                              <b
                                _ngcontent-ng-c1136689866=""
                                className="stake-amount"
                              >
                                Quick Stake
                              </b>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div
                        _ngcontent-ng-c1136689866=""
                        className="row row5 mb-1 col-md-6 col-lg-7 desktop-pl"
                      >
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn0"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn1"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn2"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn3"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn4"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn5"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn6"
                            />
                          </div>
                        </div>
                        <div
                          _ngcontent-ng-c1136689866=""
                          className="col-3 col-sm-3 col-md-3 mt-2 betstack ng-star-inserted"
                        >
                          <div
                            _ngcontent-ng-c1136689866=""
                            className="form-group mb-0"
                          >
                            <input
                              _ngcontent-ng-c1136689866=""
                              type="text"
                              min={1}
                              max={99999999}
                              maxLength={9}
                              className="form-control ng-untouched ng-pristine ng-valid"
                              id="stackbtn7"
                            />
                          </div>
                        </div>
                        {/**/}
                      </div>
                      <div _ngcontent-ng-c1136689866="" className="col-12">
                        <button
                          _ngcontent-ng-c1136689866=""
                          type="button"
                          className="col btn btn-send mt-4 mb-2"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </app-account>
  );
}
